export {default} from './Footer';



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/index.tsx